/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ScalarOperators } from '../models/ScalarOperators';

export class AccountIdCondition {
  'operator': ScalarOperators;
  'accountIds': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ScalarOperators",
      "format": ""
    },
    {
      "name": "accountIds",
      "baseName": "accountIds",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AccountIdCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



